import zipcodes from "./zipcodes.json";

const selectors = {
  block: "[data-rp]",

  form: "[data-rp-form]",
  formInput: "[data-rp-form-input]",
  formList: "[data-rp-form-list]",
};

const renderResults = (list, results) => {
  if (!results.length) {
    return list.classList.remove("active");
  }

  const resultNodes = results.map(
    ({ zipcode, city }) =>
      `<span class="py-2 px-3 text-body-300 hover:text-heading transition-colors cursor-pointer">${zipcode} ${city}</span>`
  );

  list.classList.add("active");
  list.innerHTML = resultNodes.join("\n");
};

const handleSearchInput = (value, list) => {
  let results = [];

  if (value.length >= 3) {
    results = zipcodes.filter(
      ({ zipcode, city }) => zipcode.toString().startsWith(value) || city.toLowerCase().includes(value)
    );
  }

  renderResults(list, results);
};

const handleSearchOptionClick = (option, input, list) => {
  input.value = option;
  list.classList.remove("active");
};

const initBlock = (block) => {
  const form = block.querySelector(selectors.form);
  const formInput = block.querySelector(selectors.formInput);
  const formList = block.querySelector(selectors.formList);

  form?.addEventListener("submit", (event) => handleFormSubmit(event));
  formInput?.addEventListener("input", ({ target: { value } }) => handleSearchInput(value.toLowerCase(), formList));
  formList?.addEventListener("click", ({ target: { textContent } }) =>
    handleSearchOptionClick(textContent, formInput, formList)
  );
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
